export default function GiftCardIcon({ size = 42 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 13H32.9412V33.0882" stroke="url(#paint0_linear_207_8)" strokeWidth="4" />
            <path d="M35 34.8824L7.05882 34.8824L7.05882 11.0882" stroke="url(#paint1_linear_207_8)" strokeWidth="4" />
            <path d="M20 11L20 34" stroke="black" strokeWidth="4" />
            <path d="M25 9C27.2091 9 29 7.20914 29 5C29 2.79086 27.2091 1 25 1C22.7909 1 21 2.79086 21 5C21 7.20914 22.7909 9 25 9Z" fill="black" />
            <path d="M15 9C17.2091 9 19 7.20914 19 5C19 2.79086 17.2091 1 15 1C12.7909 1 11 2.79086 11 5C11 7.20914 12.7909 9 15 9Z" fill="black" />
            <defs>
                <linearGradient id="paint0_linear_207_8" x1="32.9412" y1="16.0588" x2="32.9412" y2="34.8824" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="paint1_linear_207_8" x1="7.05882" y1="27.8235" x2="7.05882" y2="9" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
}
